import React from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'
import { useState } from 'react'

export default function HotswapTabsLayout({ tabs }) {
    const classes = useStyles()
    const [selectedTab, setSelectedTab] = useState(0)

    const handleChange = changeTabNumber => setSelectedTab(changeTabNumber)

    function TabPanel(props) {
        const { children, value, index } = props

        return value === index ? children : null
    }

    return (
        <>
            <Tabs
                value={selectedTab}
                onChange={(e, value) => {
                    handleChange(value)
                }}
                indicatorColor="primary"
                textColor="primary">
                {tabs.map(tab => (
                    <Tab key={tab.label} label={tab.label} />
                ))}
            </Tabs>
            {tabs.map((tab, index) => (
                <TabPanel
                    key={tab.label}
                    value={selectedTab}
                    index={index}
                    className={classes.tab}>
                    {tab.content}
                </TabPanel>
            ))}
        </>
    )
}

const useStyles = makeStyles(() => ({
    selectedTab: {
        backgroundColor: 'white'
    },
    root: {
        flexGrow: 1,
        backgroundColor: '#f0f0f0 !important'
    },
    tab: {
        color: '#000',
        '&.Mui-selected': {
            backgroundColor: '#1976D2',
            color: '#fff' // Text color for selected tab
        }
    }
}))
